import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { useOfferContext } from '../../../../context';

export const ChatButtonContainer: React.VFC = () => {
  const { offer, api, isChatAvailable } = useOfferContext();

  const handleClick = React.useCallback(
    e => {
      e.stopPropagation();
      api.openChat(offer);
    },
    [offer, api],
  );

  if (!isChatAvailable) {
    return null;
  }

  return (
    <Button data-mark="ChatButton" fullWidth size="XS" onClick={handleClick} theme="fill_secondary">
      Написать
    </Button>
  );
};
